<div class="demo">
  <pa-info-block [blockTitle]="'Только текст отступом small '">
    <pa-data-list size="small" [data]="textData"></pa-data-list>
  </pa-info-block>

  <pa-info-block [blockTitle]="'Только текст отступом large '">
    <pa-data-list size="large" [data]="textData"></pa-data-list>
  </pa-info-block>

  <pa-info-block [blockTitle]="'Смешанные данные, стандартный размер отступа'">
    <pa-data-list [data]="mixedData"></pa-data-list>
  </pa-info-block>

  <pa-info-block [blockTitle]="'Текст с зачёркиванием'">
    <pa-data-list [data]="lineThroughData"></pa-data-list>
  </pa-info-block>

  <pa-info-block [blockTitle]="'Состояния валидации (импорт ПВЗ из файла)'">
    <pa-data-list [data]="validationData"></pa-data-list>
  </pa-info-block>
</div>